"use client";

import { useState } from "react";
import { GamutSlice } from "@/components/common/gamut-slice";
import { DemoWrapper } from "@/components/demos/demo-wrapper";
import { StripeSlider } from "@/components/forms/stripe-slider";
import { color } from "@/lib/color";
import {
  axisGradient,
  chromaField,
  chromaOutline,
} from "@/lib/gamut-projection";

const DEFAULT_LIGHTNESS = 65;
const SAMPLE_CHROMA = 0.15;
const SAMPLE_HUE = 250;

export function MaxChromaExample() {
  const [percent, setPercent] = useState(DEFAULT_LIGHTNESS);
  const lightness = percent / 100;

  return (
    <DemoWrapper
      caption={
        <span className="select-none text-fg-muted text-sm">
          The solid line is sRGB, the dashed line is Display P3.
        </span>
      }
      className="gap-1 bg-gray-100 p-1"
    >
      <div
        aria-label="Chroma by hue at the selected lightness"
        className="relative aspect-2/1 w-full overflow-hidden rounded-lg"
        role="img"
      >
        <GamutSlice
          field={chromaField(lightness)}
          outline={(space) => chromaOutline(lightness, space)}
        />
        <div className="absolute inset-0 rounded-lg outline-subtle" />
      </div>
      <div className="w-full p-1">
        <StripeSlider
          ariaLabel="Lightness"
          background={axisGradient(
            "l",
            color(lightness, SAMPLE_CHROMA, SAMPLE_HUE)
          )}
          max={100}
          onChange={setPercent}
          value={percent}
        />
      </div>
    </DemoWrapper>
  );
}
